import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpHeaders,
  HttpEventType
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class RequestPayloadInterceptor implements HttpInterceptor {
  authToken:any = '';

  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Skip interception for IP address API
    if (request.url.includes('ipify.org')) {
      return next.handle(request);
    }

    const hasViaParameter = this.hasViaParameter(request.body);
    let modifiedRequest: HttpRequest<any>;
    const authHeader = request.body?.call_from === 'saml_skip_pass' ? `Bearer ${request.body.saml_token}` : `Bearer ${this.authToken}`;

    if (!hasViaParameter) {
      const contentType = request.headers.get('Content-Type');
      if (contentType === 'application/json') {
        const modifiedBody = {
          ...request.body,
          via: 'web_dashb'
        };

        modifiedRequest = request.clone({
          body: modifiedBody,
          setHeaders: {
            Authorization: authHeader
          }
        });
      } else if (contentType === 'multipart/form-data') {
        const formData = new FormData();
        formData.append('via', 'web_dashb');

        modifiedRequest = request.clone({
          body: formData,
          setHeaders: {
            Authorization: authHeader
          }
        });
      } else if (contentType === 'application/x-www-form-urlencoded') {
        const modifiedBody = new URLSearchParams(request.body);
        modifiedBody.set('via', 'web_dashb');

        modifiedRequest = request.clone({
          body: modifiedBody.toString(),
          setHeaders: {
            Authorization: authHeader
          },
          headers: new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded'
          })
        });
      } else {
        modifiedRequest = request.clone({
          setHeaders: {
            Authorization: authHeader
          }
        });
      }
    } else {
      modifiedRequest = request.clone({
        setHeaders: {
          Authorization: authHeader
        }
      });
    }

    return next.handle(modifiedRequest).pipe(
      tap ((event: any) => {
        // MFA issues the JWT from verifyMfaOtp (URL has no 'login'); capture it here too, else post-MFA calls send 'Bearer undefined'.
        if ((event.type === HttpEventType.Response) && (event.url.includes('login') || event.url.includes('verifyMfaOtp')) ) {
          const res_data = event?.body;
          if (res_data?.data?.[0]) {
            res_data.data = res_data?.data[0];
          };
          this.authToken = res_data?.data?.authorization;
          // const headers: HttpHeaders = event.headers;
          // const headersKeys: string[] = headers.keys();
          // headersKeys.forEach((key: string) => {
          //   const headerValue: string | null = headers.get(key);
          //   if (key == 'authorization') {
          //     this.authToken = headerValue;
          //   };
          // });
        };
      })
    )
  }

  private hasViaParameter(body: any): boolean {
    return body && body.via !== undefined;
  }
}
